import { PosnerTopbar } from '@p31ca/design-core/compositions'
import { chrome } from './chrome'
import { topbarPorts } from './topbar-ports'

/**
 * Topbar — the forge's compact chrome composed from the CONFIG (data + ports;
 * rule 0). profile 'compact' renders brand + inline trailing actions — no
 * drawer, no overflow, no chips. Brand strings come from `chrome.topbar`; the
 * controls from `topbarPorts`. ≤15 lines.
 */
export function Topbar() {
  return <PosnerTopbar {...chrome.topbar} profile="compact" {...topbarPorts()} />
}

export default Topbar